import React, { useState } from "react";
import "./TasksOverTime.css";
import { ReactComponent as ChartIcon } from "../../icons/TasksOverTime.svg";

function TasksOverTime({ dailyTasksSolvedLast7Days, percentageChange }) {
  const [hoverIndex, setHoverIndex] = useState(null);

  const tasksData = Object.entries(dailyTasksSolvedLast7Days).map(
    ([date, value]) => ({
      date,
      value,
    })
  );

  const totalTasks = tasksData.reduce((sum, task) => sum + task.value, 0);

  return (
    <div className="tasks-over-time-card">
      <h3>
        <ChartIcon className="header-emoji" />
        <span className="header-text">За последние 7 дней</span>
      </h3>
      <div className="tasks-over-time-header">
        <p className="total-tasks">
          <strong>{totalTasks} задач</strong>
        </p>
        <div className="percentage-badge">+{percentageChange}%</div>
      </div>

      <div className="bar-chart">
        {tasksData.map((task, index) => (
          <div
            key={index}
            className={`bar ${task.date === "сегодня" ? "today" : ""}`}
            style={{ height: `${task.value * 10}px` }}
            onMouseEnter={() => setHoverIndex(index)}
            onMouseLeave={() => setHoverIndex(null)}
          >
            {hoverIndex === index && (
              <span className="bar-label">{task.value}</span>
            )}
          </div>
        ))}
      </div>

      <div className="date-labels">
        {tasksData.map((task, index) => (
          <span key={index} className="date-label">
            {task.date}
          </span>
        ))}
      </div>
    </div>
  );
}

export default TasksOverTime;
